export default __webpack_public_path__ + "static/media/Header-19.84dfa1d5.jpg";